import React from 'react';
import { Button, Modal } from 'antd';

/**
 * The 409 of a stale Done (ruled d17; keepr-api SCHEMA "Dashboards"): someone
 * else saved the dashboard while this person was arranging it. Nothing is
 * merged silently — the arranger chooses:
 *
 *   Load their version   drop the draft and show the dashboard the 409 carried
 *   Save mine over it    send the same layout again, at the version it named
 *
 * Closing the window keeps arranging, the draft as it was.
 */
export default function VersionConflictModal({ open, saving = false, onLoadTheirs, onSaveMine, onClose }) {
	return (
		<Modal
			open={open}
			title='Someone else saved this dashboard'
			onCancel={onClose}
			className='version-conflict-modal'
			footer={[
				<Button key='theirs' autoFocus onClick={onLoadTheirs} disabled={saving}>Load their version</Button>,
				<Button key='mine' danger loading={saving} onClick={onSaveMine}>Save mine over it</Button>,
			]}
		>
			<p>Someone saved a change to this dashboard while you were arranging it.</p>
			<p>
				<strong>Load their version</strong>
				{' to drop your changes and see theirs, or '}
				<strong>Save mine over it</strong>
				{' to replace their changes with your layout.'}
			</p>
		</Modal>
	);
}
